var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useMemo, useState } from 'react';
import { useUpdateCheckCodeApi } from '../../hooks/api/code/useUpdateCheckCodeApi';
import { useDispatch } from 'react-redux';
import { GeneralActions } from '../../redux';
import { useLanguage } from '../../locale';
import { useController, useForm } from 'react-hook-form';
import { useUpdateCodeAssignApi } from '../../hooks/api/code/useUpdateCodeAssignApi';
import { useQueryClient } from '@tanstack/react-query';
import { refreshUserDataAfterCodeRedeem } from '../../hooks/api/utils';
export var useFamilyCheckFacade = function (onNext) {
    var _a;
    var t = useLanguage()[0];
    var _b = useState(false), visible = _b[0], setVisible = _b[1];
    var _c = useForm({
        mode: 'onSubmit',
    }), control = _c.control, handleSubmit = _c.handleSubmit;
    var _d = useController({
        name: 'code',
        control: control,
        rules: {
            required: {
                value: true,
                message: t('memberRegistry.familyCheckInputLengthError'),
            },
        },
    }), field = _d.field, fieldState = _d.fieldState;
    var value = field.value, onChange = field.onChange;
    var dispatch = useDispatch();
    var queryClient = useQueryClient();
    //** API **//
    var checkCode = useUpdateCheckCodeApi().mutateAsync;
    var codeAssign = useUpdateCodeAssignApi().mutateAsync;
    //** DATA **//
    var onCheckCode = useMemo(function () {
        return handleSubmit(function (data) { return __awaiter(void 0, void 0, void 0, function () {
            var checkRes, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 6, , 7]);
                        return [4 /*yield*/, checkCode(data.code)];
                    case 1:
                        checkRes = _a.sent();
                        if (!(!(checkRes === null || checkRes === void 0 ? void 0 : checkRes.used) === false)) return [3 /*break*/, 4];
                        return [4 /*yield*/, codeAssign(data.code)];
                    case 2:
                        _a.sent();
                        setVisible(false);
                        // Aspetta che tutti i dati siano aggiornati
                        return [4 /*yield*/, refreshUserDataAfterCodeRedeem(queryClient)];
                    case 3:
                        // Aspetta che tutti i dati siano aggiornati
                        _a.sent();
                        // Imposta gli stati Redux solo dopo che i dati sono aggiornati
                        dispatch(GeneralActions.setIsMemberRegistryCompleted(true));
                        dispatch(GeneralActions.setIsFirstSignUp(false));
                        dispatch(GeneralActions.setIsPlanCreated(true));
                        return [3 /*break*/, 5];
                    case 4:
                        setVisible(true);
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        error_1 = _a.sent();
                        console.error('Error during code redemption:', error_1);
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        }); });
    }, [checkCode, codeAssign, dispatch, handleSubmit, queryClient]);
    //** CALLBACK **//
    var onConfirmPress = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    setVisible(false);
                    return [4 /*yield*/, codeAssign(value)];
                case 1:
                    _a.sent();
                    // Aspetta che tutti i dati siano aggiornati
                    return [4 /*yield*/, refreshUserDataAfterCodeRedeem(queryClient)];
                case 2:
                    // Aspetta che tutti i dati siano aggiornati
                    _a.sent();
                    // Imposta gli stati Redux solo dopo che i dati sono aggiornati
                    dispatch(GeneralActions.setIsMemberRegistryCompleted(true));
                    dispatch(GeneralActions.setIsFirstSignUp(false));
                    dispatch(GeneralActions.setIsPlanCreated(true));
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    console.error('Error during code confirmation:', error_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [codeAssign, dispatch, value, queryClient]);
    var onDeniedPress = useCallback(function () {
        setVisible(false);
        dispatch(GeneralActions.setIsFirstSignUp(true));
        onNext();
    }, [dispatch, onNext]);
    var onIconCancelPress = useCallback(function () {
        setVisible(false);
    }, []);
    return {
        value: value,
        setValue: onChange,
        visible: visible,
        errorMessage: (_a = fieldState.error) === null || _a === void 0 ? void 0 : _a.message,
        onCheckCode: onCheckCode,
        onConfirmPress: onConfirmPress,
        onDeniedPress: onDeniedPress,
        onIconCancelPress: onIconCancelPress,
        setVisible: setVisible,
    };
};
